/**
 * Countdown for the chapter section.
 *
 * The target is read from data-until as a plain date/time string, which the
 * browser interprets in the shopper's own timezone — the same wall-clock
 * deadline everyone sees written on the page. Once it passes, the block hides
 * itself rather than counting upwards into negative numbers.
 */
if (!customElements.get('chapter-countdown')) {
  class ChapterCountdown extends HTMLElement {
    connectedCallback() {
      const bruto = this.dataset.until;
      if (!bruto) return;

      this.alvo = new Date(bruto.includes('T') ? bruto : `${bruto}T23:59:59`);
      if (Number.isNaN(this.alvo.getTime())) return;

      this.saidas = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        min: this.querySelector('[data-unit="min"]'),
        sec: this.querySelector('[data-unit="sec"]'),
      };

      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const restante = this.alvo - Date.now();

      if (restante <= 0) {
        clearInterval(this.timer);
        this.hidden = true;
        return;
      }

      const segundos = Math.floor(restante / 1000);
      const valores = {
        days: Math.floor(segundos / 86400),
        hours: Math.floor(segundos / 3600) % 24,
        min: Math.floor(segundos / 60) % 60,
        sec: segundos % 60,
      };

      Object.entries(valores).forEach(([unidade, valor]) => {
        const saida = this.saidas[unidade];
        if (saida) saida.textContent = String(valor).padStart(2, '0');
      });
    }
  }

  customElements.define('chapter-countdown', ChapterCountdown);
}
